module.exports = __webpack_public_path__ + "static/media/somethings-different.4a8c1a05.mp3";